export const BRAND = {
  nome: "NILLO RUÍDOS",
  titulo: "NILLO RUÍDOS - TRATAMENTO DE RUÍDOS E ISOLAMENTO TERMOACÚSTICO",
  slogan: "Excelência em conforto.",
  frase: "Tratamento de ruídos não é improviso.",
  assinatura: "Seu carro novo, de novo.",
  telefone: "(21) 96469-9478",
  whatsapp: "5521964699478",
  site: "https://nilloruidos.blogspot.com",
  instagram: "@nilloruidos",
  facebook: "@nilloruidos",
  atendimento: "Todo Brasil",
  responsavel: "Nillo",
  fabricantesUrl: "https://nilloservicos.blogspot.com/2014/04/nimod.html",
  waMensagem: "Olá, Nillo Ruídos. Segue a solicitação de orçamento/ordem de serviço gerada pelo sistema.",
};

export const waLink = (text, number = BRAND.whatsapp) =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const LINKS = [
  { titulo: "WhatsApp", url: "https://wa.me/5521964699478" },
  { titulo: "Site", url: "https://nilloruidos.blogspot.com" },
  { titulo: "Instagram", url: "https://instagram.com/nilloruidos" },
  { titulo: "Facebook", url: "https://facebook.com/nilloruidos" },
  { titulo: "Serviços por fabricante", url: "https://nilloservicos.blogspot.com/2014/04/nimod.html" },
];

export const MENU = [
  { label: "Início", to: "/" },
  { label: "Tratamento de Ruídos", to: "/tratamento-de-ruidos" },
  { label: "Isolamento Termoacústico", to: "/isolamento-termoacustico" },
  { label: "Diagnóstico", to: "/diagnostico" },
  { label: "Pacotes", to: "/pacotes" },
  { label: "Dr. Ruídos", to: "/dr-ruidos" },
  { label: "Orçamento", to: "/orcamento" },
  { label: "Ordem de Serviço", to: "/ordem-de-servico" },
  { label: "Informativos", to: "/informativos" },
  { label: "Garantia", to: "/garantia" },
  { label: "Contato", to: "/contato" },
];

export const DESTAQUES = ["Mais silêncio", "Mais conforto", "Menos vibrações", "Melhor experiência ao dirigir"];

export const GARANTIA = {
  titulo: "TERMO DE GARANTIA",
  periodo: "90 dias",
  texto: "Garantia de 90 (noventa) dias, contados a partir da data de realização do atendimento.",
  condicoes: [
    "Os custos de deslocamento para eventuais atendimentos em garantia serão de responsabilidade do contratante.",
    "Durante o período de garantia não haverá cobrança de materiais ou mão de obra em caso de necessidade de intervenção relacionada ao serviço contratado.",
  ],
};

export const RESSALVAS = {
  nao_inclusos: ["Lavagem do veículo", "Aspiração do veículo", "Serviços mecânicos", "Serviços elétricos", "Instalação de componentes elétricos ou eletrônicos", "Instalação de acessórios", "Lanternagem", "Funilaria", "Manutenção de ar-condicionado"],
  nao_responsabilidade: ["Defeitos pré-existentes", "Problemas mecânicos", "Problemas elétricos", "Problemas de ar-condicionado", "Instalações", "Amassados", "Colisões", "Problemas estruturais", "Problemas relacionados à blindagem", "Peças ressecadas, desgastadas ou parcialmente danificadas"],
  observacao: "Podem permanecer ruídos crônicos residuais quando sua origem estiver relacionada a problemas estruturais, blindagem, peças danificadas ou outras condições que não sejam de origem acústica isolável.",
};

export const MATERIAIS = {
  titulo: "TECNOLOGIA DOS MATERIAIS",
  descricao: "Utilização de materiais têxteis de engenharia com propriedades antifúngicas e hidrofóbicas.",
  nao_utilizados: ["Materiais asfálticos", "Materiais butílicos"],
};

export const RESULTADO = "Os serviços são apresentados como capazes de proporcionar redução média entre 40% e 70% dos ruídos existentes, variando conforme as condições estruturais e o estado geral do veículo.";

export const ATENDIMENTO = {
  regiao: "Todo Brasil",
  preferencial: ["Shopping centers", "Estacionamentos", "Supermercados"],
  domicilio: "Atendimento a domicílio mediante análise de viabilidade técnica.",
  condicoes_local: ["Local coberto", "Banheiro público", "Segurança", "Facilidade de movimentação", "Possibilidade de refeição rápida"],
  observacao: "O endereço informado pelo cliente deverá ser analisado antes da confirmação do atendimento.",
};

export const DESLOCAMENTO = {
  observacao: "Atendimentos fora do município do Rio de Janeiro podem possuir custo de deslocamento.",
  domicilio: "O cliente deve informar o endereço para análise de viabilidade técnica e estimativa de custos.",
};

export const LOCAIS = ["Shopping center", "Estacionamento", "Supermercado", "Domicílio (sujeito a análise de viabilidade)"];

export const PAGAMENTO = {
  opcoes: ["Pix", "Cartão de crédito", "Outra opção a combinar"],
  bancos: ["Santander", "Itaú", "Bradesco", "Caixa Econômica Federal", "Banco do Brasil", "NuBank", "XP", "Mastercard", "RedeShop", "Visa"],
  fora: { sinal: "20%", saldo: "A combinar" },
};

export const ACEITE = {
  titulo: "CONFIRMAÇÃO DE ACEITAÇÃO",
  botao: "ACEITO O ORÇAMENTO E AUTORIZO A RESERVA",
  advertencia: "O cliente declara estar ciente de que valores pagos para reserva não serão devolvidos quando destinados ao custeio da preparação logística necessária para o atendimento.",
};

export const MISSAO = "Transformar o tratamento de ruídos e o isolamento termoacústico automotivo em um serviço profissional, técnico e reconhecido pelo mercado, proporcionando mais conforto, qualidade e satisfação aos clientes.";
export const VISAO = "Ser reconhecida como uma das principais referências brasileiras em tratamento profissional de ruídos e isolamento termoacústico automotivo.";

export const STATUS_LABEL = {
  aguardando_precificacao: "Aguardando precificação",
  aguardando_aceite: "Aguardando aceite do cliente",
  aceita: "Aceita pelo cliente",
  em_execucao: "Em execução",
  concluida: "Concluída",
  cancelada: "Cancelada",
};

export const DR_STATUS = {
  inspecao_solicitada: "Inspeção solicitada",
  inspecao_confirmada: "Inspeção confirmada",
  concluido: "Concluído",
  cancelado: "Cancelado",
};
